<template>
<validation-observer ref="observer" v-slot="{ passes }">
    <b-form @submit.prevent="passes(onFormSubmit)" novalidate>
    <b-overlay 
        :show="$store.getters['loading/isLoading']('memo')"
        rounded="sm"
        variant="light"
        spinner-variant="primary"
        :opacity="0.80"
        blur="2px">
        <b-form-group :disabled="isLocked">
            <validation-provider vid="description" v-slot="{ errors }">
            <b-form-group
                :invalid-feedback="errors[0]"
                :state="errors[0] ? false : null">
                <b-form-textarea id="description" v-capitalize trim v-model="form.description" placeholder="Add memo..." rows="5" max-rows="8"></b-form-textarea>
            </b-form-group>
            </validation-provider>
        </b-form-group>
    </b-overlay>
    <template v-if="checkUserPermission('memo', 'can_change')">
        <b-button class="mr-1" :disabled="isLocked" type="submit" variant="success"><i class="fa-regular fa-circle-dot"></i> Submit</b-button>
        <b-button v-if="isLocked" type="button" variant="warning" @click="isLocked = false"><i class="fa-solid fa-unlock"></i> Unlock</b-button>
        <b-button v-if="!isLocked && !isDirty && !hasErrors" type="button" variant="outline-primary" @click="isLocked = true"><i class="fa-solid fa fa-lock"></i> Lock</b-button>
        <b-button v-if="isDirty || hasErrors" type="button" variant="danger" @click="reset"><i class="fa-solid fa-ban"></i> Reset</b-button>
    </template>
</b-form>
</validation-observer>	
</template>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapGetters, mapState, mapActions } from "vuex"

export default FormExtension.extend({
    name: 'memo-form',
    data() {
        return {
            form: new Form({
            	description: "",
                consistency_token: null
            })
        }
    },
    computed: {
        ...mapGetters('patients', ['getPatientMemo']),
        memo() {
            return this.getPatientMemo()
        }
    },
    watch: {
        memo: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.form = Form.create(val)                    
                }else{
                    this.form = Form.create({
                        description: "",
                        consistency_token: null
                    })
                }
            }
        },
        form: {
            deep: true,
            handler(val) {
                this.isDirty = this.form.dirty()

                if (this.isDirty) {
                    this.dirty()
                }else{
                    this.validated()
                }
            }
        }
    },
    methods: {
        ...mapActions('patients', ['getMemoForCurrentPatient', 'createPatientMemo', 'updatePatientMemo']),
        async loadForPatient(patient) {
            await this.getMemoForCurrentPatient()
        },
        create() {
            this.createPatientMemo(this.form.data()).then(() => {
                this.notify("Patient memo created", "Patient memo was created successfully")
                this.isLocked = true
                this.$emit('saved')
            })
            .catch(errors => {
                if (errors.response) {
                    this.$refs.observer?.setErrors(errors.response.data)
                    this.hasErrors = true
                }
            })
        },
        update() {
            this.updatePatientMemo({id: this.memo?.id, data: this.form.data() }).then(() => {
                this.notify("Patient memo updated", "Patient memo was updated successfully")
                this.isLocked = true
                this.$emit('saved')
            })
            .catch(errors => {
                if (errors.response) {
                    this.$refs.observer?.setErrors(errors.response.data)
                    this.hasErrors = true
                }
            })
        },
        onFormSubmit() {
            if (this.memo) {
                this.update()
            }else{
                this.create()
            }
        },
        reset() {
            this.form.reset()

            this.$nextTick(() => {
                this.$refs.observer?.reset()
                this.hasErrors = false
                this.isLocked = true
                this.validated()
            })
        }
    }
})
</script>